<template>
    <div class="header_container">
      <el-breadcrumb separator="/">
        <!--<el-breadcrumb-item :to="{ path: '/manage' }">首页</el-breadcrumb-item>-->
        <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">{{item}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-dropdown trigger="hover">
        <span class="el-dropdown-link userinfo-inner">{{sysUserName}}
        <img src="../assets/portrait.png" class="userinfo-img"/>
          </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="dialogFormVisible = true">修改密码</el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dialog title="修改密码"  :visible.sync="dialogFormVisible" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="原密码" prop="name">
            <el-input v-model="addForm.initialPassword" auto-complete="off" maxlength="5" type="password"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="name">
            <el-input v-model="addForm.password" auto-complete="off" maxlength="5" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="name">
            <el-input v-model="addForm.passwords" auto-complete="off" maxlength="5" type="password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()" >提交</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import { getloginout,getpasswordTopMod } from "../api/api"
    export default {
    	data(){
    		return {
          addForm: {
            initialPassword:'',
            password:'',
            passwords:'',
          },
          sysUserName:'',
          dialogFormVisible:false,
          loading:false
    		}
    	},
    	created(){

    	},
    	computed: {
    	},
      methods: {
        logout: function () {
          this.$confirm('确认退出吗?', '提示', {
            //type: 'warning'
          }).then(() => {
            let params={
              id:JSON.parse(sessionStorage.getItem('user')).id,
            };
            getloginout(params).then((res)=>{
              if (res.state == true){
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                sessionStorage.removeItem('token')
                this.$router.push('/');
              }else{
                throw new Error(res.message)
              }
            }).catch(error=>{

            })

          }).catch(() => {

          });
        },
        //修改密码
        addSubmit(){
          if (this.addForm.password == ''  || this.addForm.passwords == ''|| this.addForm.initialPassword == ''){
            this.$message({
              type: 'error',
              message: '请输入完整信息'
            });
          } else if(this.addForm.passwords != this.addForm.password){
            this.$message({
              type: 'error',
              message: '两次密码不一致'
            });
          }else {
            this.loading = true
            let params={
              password:this.addForm.password,
              id:JSON.parse(sessionStorage.getItem('user')).id,
              operationId:JSON.parse(sessionStorage.getItem('user')).id,
              initialPassword:this.addForm.initialPassword
            };
            getpasswordTopMod(params).then(res=>{
              console.log(res)
              if (res.state == true) {
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.loading = false
                this.dialogFormVisible = false
                this.$store.commit('del_token');
                sessionStorage.removeItem('user')
                this.$router.push('/');
              }else{
                this.$message({
                  type: 'error',
                  message: '原密码错误'
                });
                this.loading = false
              }
            }).catch(error=>{
              this.loading = false
              console.log(error)
            })
          }
        },
        cancel(){
          this.addForm = {}
          this.dialogFormVisible = false
        },
      },
      mounted() {
        let user = sessionStorage.getItem('user');
        if (user) {
          user = JSON.parse(user);
          this.sysUserName = user.name || '';
        }

      }
    }
</script>

<style lang="less">
	@import '../style/mixin';
	.header_container {
    background-color: #EFF2F7;
    height: 60px;
    display: flex;
    line-height: 60px;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }
  .userinfo {
    text-align: right;
    padding-right: 35px;
    float: right;
  }
  .userinfo-inner {
    cursor: pointer;
  }
  .userinfo-img{
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin: 10px 0px 10px 10px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/headTop.vue